import { AuthProvider } from './contexts/AuthContext';
import { ProfilesProvider } from './contexts/ProfilesContext';
import { ToastProvider } from './contexts/ToastContext';
import Dashboard from './Dashboard';

function App() {
  return (
    <AuthProvider>
      <ProfilesProvider>
        <ToastProvider>
          <Dashboard />
        </ToastProvider>
      </ProfilesProvider>
    </AuthProvider>
  );
}

export default App;
